import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar'
import { TranslateModule } from '@ngx-translate/core'
import { Observable, Subject, take } from 'rxjs'

@Component({
  selector: 'gb-ok-snack-bar',
  templateUrl: './gb-ok-snack-bar.component.html',
  styleUrls: ['./gb-ok-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatSnackBarModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, TranslateModule],
})
export class GbOkSnackBarComponent implements OnInit {
  private actionSubject = new Subject<boolean>()

  snackBarRef = inject(MatSnackBarRef<GbOkSnackBarComponent>)
  public data: { message: string } = inject(MAT_SNACK_BAR_DATA)

  ngOnInit(): void {
    this.snackBarRef
      .afterDismissed()
      .pipe(take(1))
      .subscribe(() => this.actionSubject.complete())
  }

  action(result: boolean): void {
    this.actionSubject.next(result)
    this.snackBarRef.dismiss()
  }

  getActionObservable(): Observable<boolean> {
    return this.actionSubject.asObservable()
  }
}
